'use client'

import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import { RevealText } from './reveal-text'

const testimonials = [
  {
    quote:
      'After Sahil redesigned our website we got lot of contracts. He not only has the skills to do the job but also he listens what you want to do and works hard to accomplish it. I highly recommend Elementary Creative to build or redesign your web site.',
    name: 'Jorge Velez',
    role: 'CEO, Ezee Computer Training',
  },
  {
    quote:
      'I had the pleasure of working with one of the easiest to deal with designers I\'ve ever met. He was very open and listened to all my ideas while at the same time providing his suggestions and expertise. I would certainly use elementarycreative for any future ventures.',
    name: 'Juan',
    role: 'Owner, Velezfit',
  },
  {
    quote:
      'From start to finish, it was a well informed and consistently great experience with them. I am very happy with the final product. Would recommend their services to everyone!',
    name: 'Michael',
    role: 'Owner, Hybrid Roofing',
  },
]

export function TestimonialsSection() {
  const ref = useRef<HTMLElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section ref={ref} className="py-32 md:py-48 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <RevealText className="mb-16 text-center">
          <span className="text-xs tracking-[0.3em] uppercase text-accent block mb-4">
            Outcomes
          </span>
          <h2 className="text-4xl md:text-6xl font-serif tracking-tight">
            What clients <span className="italic text-muted-foreground">say.</span>
          </h2>
        </RevealText>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, index) => (
            <motion.blockquote
              key={t.name}
              className="p-8 border border-border bg-card/30 flex flex-col"
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <p className="text-lg text-muted-foreground font-serif italic leading-relaxed flex-1 mb-8">
                &ldquo;{t.quote}&rdquo;
              </p>
              <footer>
                <p className="font-medium">{t.name}</p>
                <p className="text-sm text-muted-foreground">{t.role}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
        </div>
    </section>
  )
}
